export default function getDashFormattedDate (dateString) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  // Проверяем валидность даты
  if (isNaN(date.getTime())) {
    return '';
  }
  
  return date.getFullYear() + '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
    ('0' + date.getDate()).slice(-2);
}
